import React, { useState, useCallback, useEffect } from "react";
import Moment from "moment";
import Icon from "../Icon/Icon";
import iconDocumentacion from "../../../img/icons/svg/historial/historial-card-05.svg";
import "./Cards.scss";
import useGetBlobs from "@/services/utils/useGetBlobs";

export interface IHealthcareDocumentProp {
  documents?: any[];
  handleRequestDocument: (documentID: string) => void;
  highlightId?: string | null;
}

const HealthcareDocumentsCards: React.FC<IHealthcareDocumentProp> = ({
  documents = [],
  handleRequestDocument,
  highlightId,
}) => {
  const [animating, setAnimating] = useState(false);
  const { getExtension, handleDownloadBlob, isDownloading } = useGetBlobs();
  // preserve original highlight pulse animation
  useEffect(() => {
    if (highlightId && documents.length > 0) {
      setAnimating(true);
      const timer = setTimeout(() => setAnimating(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [highlightId, documents.length]);

  const handleDownload = useCallback(async (uri: string, nombre: string) => {
    await handleDownloadBlob(uri, nombre);
  }, []);

  if (!documents.length) {
    return <p className="cards-empty">No hay documentos para mostrar.</p>;
  }

  return (
    <div className={animating ? "highlight-cards-pulse" : ""}>
      <div className="cards-list">
        {documents.map((doc: any, i: number) => {
          const ext = getExtension(doc.nombre);
          const isDownloadingDoc =  isDownloading(doc.uri);
          return (
            <article key={doc.id || i} className="item-card item-card--compact">
              <div
                className="item-card__icon"
                style={{ background: "#4061ce" }}
              >
                <img
                  src={iconDocumentacion}
                  alt="documentación"
                  style={{ width: 22, height: 22, objectFit: "contain" }}
                />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{doc.nombre}</div>
                <div className="item-card__meta">
                  {ext && <span className="item-card__sub">{ext}</span>}
                  {doc.company && doc.company !== "-" && (
                    <span className="item-card__sub">{doc.company}</span>
                  )}
                  {doc.fecha && (
                    <span className="item-card__sub">
                      {Moment(doc.fecha).format("DD MMM YYYY")}
                    </span>
                  )}
                </div>
              </div>
              <div className="item-card__action">
                <button
                  className="item-card__download-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (doc.requiereOtp === false) {
                      handleDownload(doc.uri, doc.nombre);
                    } else {
                      handleRequestDocument(doc.id);
                    }
                  }}
                  title={
                    doc.requiereOtp === false
                      ? "Descargar"
                      : "Verificar y descargar"
                  }
                  disabled={isDownloadingDoc}
                >
                  <Icon name="download" size={14} />
                  {doc.requiereOtp === false ? isDownloadingDoc ? "Descargando" : "Descargar" : "Verificar"}
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default HealthcareDocumentsCards;
